import React, { useState } from 'react';
import Modal from './Modal';
import Button from './Button';
import Icon from '../AppIcon';
import { useAuth } from '../../contexts/AuthContext';

const UpgradeModal = ({ isOpen, onClose }) => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleUpgrade = async (planType) => {
    if (!user?.id) {
      setError('Please log in to upgrade');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const monthlyUrl = 'https://buy.stripe.com/28E9AN9Fodgv9q5eiodEs01';
      const annualUrl = 'https://buy.stripe.com/cNi00dbNwccreKpb6cdEs00';
      
      const url = planType === 'monthly' ? monthlyUrl : annualUrl;
      
      if (url) {
        // Redirect to Stripe Checkout
        window.location.href = url;
      } else {
        throw new Error('Payment URL not configured');
      }
    } catch (err) {
      console.error('Upgrade error:', err);
      setError(err?.message || 'Failed to start checkout. Please try again.');
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Trial Period Ended" showCloseButton={false}>
      <div className="space-y-4">
        <div className="flex items-start gap-3 p-4 rounded-lg" style={{ backgroundColor: 'var(--color-warning-background)' }}>
          <div className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: 'var(--color-warning)' }}>
            <Icon name="Clock" size={20} color="var(--color-warning-foreground)" />
          </div>
          <div className="flex-1">
            <h3 className="text-sm font-semibold mb-1" style={{ color: 'var(--color-text-primary)' }}>
              Your 7-Day Trial Has Expired
            </h3>
            <p className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>
              To continue using GalleyPlan's meal planning and inventory management features, please upgrade to our premium subscription.
            </p>
          </div>
        </div>

        <div className="space-y-3">
          <h4 className="text-sm font-semibold" style={{ color: 'var(--color-text-primary)' }}>
            Premium Features Include:
          </h4>
          <ul className="space-y-2">
            {[
              'Unlimited trip duration',
              'Advanced meal planning',
              'Complete inventory management',
              'Shopping list generation',
              'Priority support'
            ]?.map((feature, index) => (
              <li key={index} className="flex items-center gap-2 text-sm" style={{ color: 'var(--color-text-secondary)' }}>
                <Icon name="Check" size={16} color="var(--color-primary)" />
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        </div>

        {error && (
          <div className="p-3 rounded-lg" style={{ backgroundColor: 'var(--color-destructive-background)' }}>
            <p className="text-sm" style={{ color: 'var(--color-destructive)' }}>{error}</p>
          </div>
        )}

        <div className="space-y-3 pt-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <Button
              variant="outline"
              size="lg"
              onClick={() => handleUpgrade('monthly')}
              disabled={loading}
              iconName={loading ? "Loader2" : "CreditCard"}
              iconClassName={loading ? "animate-spin" : ""}
              iconPosition="left"
              className="w-full"
            >
              {loading ? 'Redirecting...' : 'Monthly Subscription'}
            </Button>
            <Button
              variant="default"
              size="lg"
              onClick={() => handleUpgrade('annual')}
              disabled={loading}
              iconName={loading ? "Loader2" : "CreditCard"}
              iconClassName={loading ? "animate-spin" : ""}
              iconPosition="left"
              className="w-full"
            >
              {loading ? 'Redirecting...' : 'Annual Subscription'}
            </Button>
          </div>
          <Button
            variant="outline"
            size="lg"
            onClick={onClose}
            disabled={loading}
            className="w-full"
          >
            Maybe Later
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UpgradeModal;